export interface ICommentFileDownloadRegistry {
  abortAll: () => void;
  finish: (commentId: number, controller: AbortController) => boolean;
  start: (commentId: number) => AbortController | null;
}

export const createCommentFileDownloadRegistry = (): ICommentFileDownloadRegistry => {
  const controllers = new Map<number, AbortController>();

  return {
    start: (commentId: number): AbortController | null => {
      if (controllers.has(commentId)) {
        return null;
      }

      const controller = new AbortController();
      controllers.set(commentId, controller);
      return controller;
    },
    finish: (commentId: number, controller: AbortController): boolean => {
      if (controllers.get(commentId) !== controller) {
        return false;
      }

      controllers.delete(commentId);
      return true;
    },
    abortAll: (): void => {
      controllers.forEach(controller => controller.abort());
      controllers.clear();
    },
  };
};
